/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".auditoriaCheck[_ngcontent-%COMP%]{display:inline-flex;float:right;padding:1vh}"];
export { styles as styles };
